module.exports = __webpack_public_path__ + "img/creators1.21b17de8.png";